import { render, staticRenderFns } from "./OnlineEducation.vue?vue&type=template&id=0617329e&scoped=true"
import script from "./OnlineEducation.vue?vue&type=script&lang=js"
export * from "./OnlineEducation.vue?vue&type=script&lang=js"
import style0 from "./OnlineEducation.vue?vue&type=style&index=0&id=0617329e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617329e",
  null
  
)

export default component.exports